import { useEffect, useState } from "react";
import { Box, Button, TextField, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import MenuSection from "../components/MenuSection";
import FuelButton from "../components/FuelButton";

const ypfPalette = {
  infinia: "#0e8fdc",
  infiniaD: "#869633",
  super: "#00468c",
  diesel500: "#a9a9a9",
  action: "#17A54D",
};

const UnitButton = ({ unit, selectedUnit, setSelectedUnit, amount, setAmount, theme }) => {
  const isSelected = selectedUnit === unit; // se transformará en input
  const isLocked = selectedUnit !== null && !isSelected; // aparece oscuro y sin clic

  /* 1. Cuando está seleccionado */
  if (isSelected) {
    return (
      <TextField
        autoFocus
        type="number"
        value={amount}
        onChange={e => setAmount(e.target.value)}
        variant="outlined"
        inputProps={{ min: 0 }}
        sx={{
          my: 1, // <-- margen vertical (5 px aprox.)
          height: 50,
          width: "80%",
          "& .MuiOutlinedInput-root": {
            borderRadius: 3,
            backgroundColor: "#D9D9D9",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#D9D9D9",
          },
          "& input": {
            textAlign: "center",
            fontWeight: "bold",
            fontSize: 20,
            letterSpacing: 1,
          },
        }}
      />
    );
  }

  /* 2. Cuando NO está seleccionado */
  return (
    <Button
      onClick={() => setSelectedUnit(unit)}
      variant="contained"
      disableElevation
      sx={{
        my: 1, // mismo margen
        height: 50,
        width: "80%",
        borderRadius: 3,
        fontWeight: "bold",
        fontSize: 20,
        letterSpacing: 1,

        /* fondo y texto cambian si está bloqueado */
        backgroundColor: isLocked ? theme.palette.grey[800] : "#D9D9D9",
        color: isLocked ? "#FFF" : theme.palette.grey[700],

        "&:hover": {
          backgroundColor: isLocked ? theme.palette.grey[800] : "#E0E0E0",
        },

        /* aseguramos color aun en estado Mui-disabled */
        "&.Mui-disabled": {
          backgroundColor: "#545454",
          color: "#FFF",
        },
      }}
    >
      {unit}
    </Button>
  );
};

export const AutoservicioPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
  const [modalWidth, setModalWidth] = useState("500px");
  const [amount, setAmount] = useState("");

  const [selectedFuel, setSelectedFuel] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const isLoadEnabled = Boolean(selectedFuel && selectedUnit && amount && parseFloat(amount) > 0);

  const fuels = [
    { label: "INFINIA", color: ypfPalette.infinia, price: "$1180,00" },
    { label: "INFINIA DIESEL", color: ypfPalette.infiniaD, price: "$1150,00" },
    { label: "SUPER", color: ypfPalette.super, price: "$1280,00" },
    { label: "DIESEL 500", color: ypfPalette.diesel500, price: "$1080,00" },
  ];
  const units = ["LITROS", "PESOS"];

  const handleLoad = () => {
    const data = {
      fuel: selectedFuel,
      unit: selectedUnit,
      amount: parseFloat(amount),
    };
    // Guarda la info
    localStorage.setItem("autoservicioSelection", JSON.stringify(data));
    // Navega a la siguiente pantalla
    navigate("/autoservicioPage/seleccionIsla");
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 700);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <MenuSection />
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Box sx={{ display: "flex", mb: 2, flexDirection: "row", justifyContent: "center", overflowX: "hidden", width: "100%" }}>
            {fuels.map(({ label, color, price }) => (
              <FuelButton
                key={label}
                label={label}
                color={color}
                price={price}
                selected={selectedFuel === label}
                dimmed={selectedFuel !== null && selectedFuel !== label}
                onClick={() => setSelectedFuel(label)}
              />
            ))}
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              ...(!isMobile && { mt: 10 }),
              mb: 2,
            }}
          >
            {units.map(unit => (
              <UnitButton
                key={unit}
                unit={unit}
                selectedUnit={selectedUnit}
                setSelectedUnit={newUnit => {
                  setSelectedUnit(newUnit);
                  setAmount(""); // Se limpia para evitar que se mantenga el valor anterior
                }}
                amount={amount}
                setAmount={setAmount}
                theme={theme}
              />
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              p: 2,
            }}
          >
            <Button
              disabled={!isLoadEnabled}
              onClick={handleLoad}
              sx={{
                minWidth: 180,
                backgroundColor: isLoadEnabled ? ypfPalette.action : "#CCC",
                color: isLoadEnabled ? "#FFF" : "#666",
                fontWeight: "bold",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: isLoadEnabled ? ypfPalette.action : "#CCC",
                },
              }}
            >
              CARGAR
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
